<div class="dev-info" *ngIf="dev">

   <h1 class="d-inline-grid">
      <span>{{ devName }}</span>
      <span class="fs-14">{{ devPhase }}</span>
   </h1>

   <div class="nav-container">
      <mnf-project-info-nav [dev]="dev"></mnf-project-info-nav>
   </div>

   <div class="card-info">
      <mnf-project-info-card [dev]="dev" [allUsersParts]="allUsersParts" [userParts]="user?.participations" [devParts]="devParts">
      </mnf-project-info-card>
   </div>

   <div class="dev-menu">
      <mat-tab-group mat-align-tabs="center" animationDuration="500ms" (selectedTabChange)="selectedTabChange($event)"
         dynamicHeight>
         <mat-tab label="Características">
            <div class="container-info border-xs-0">
               <mnf-project-info-detail [dev]="dev"></mnf-project-info-detail>
            </div>
         </mat-tab>
         <!-- <mat-tab label="Proyección financiera">
            <div class="container- container-info border-xs-0">
               <mnf-project-info-projection [dev]="dev" [selectedIndex]="selectedIndex"></mnf-project-info-projection>
            </div>
         </mat-tab> -->
         <!-- <mat-tab label="Resultado Operativo">
            <div class="container-info border-xs-0">
               <mnf-project-info-operation [dev]="dev" [selectedIndex]="selectedIndex"></mnf-project-info-operation>
            </div>
         </mat-tab> -->
         <mat-tab label="Ubicación">
            <div class="container-info border-xs-0">
               <mnf-project-info-location [dev]="dev" [selectedIndex]="selectedIndex"></mnf-project-info-location>
            </div>
         </mat-tab>
         <mat-tab label="Desarrollador" *ngIf="dev.developer?.company">
            <div class="container-info border-xs-0">
               <mnf-project-info-developer [dev]="dev" [selectedIndex]="selectedIndex"></mnf-project-info-developer>
            </div>
         </mat-tab>

         <mat-tab label="Inversión" *ngIf="regaliaInfo">
            <div class="container-regalia mb-5" #containerRegalia>
               <div *ngIf="showImageRegalia else noShowImagenRegalia">
                  <img [src]="regaliaInfo" alt="">
               </div>
               <ng-template #noShowImagenRegalia>
                  <!-- <iframe scrolling="auto" frameborder=0 width="{{ width || 300}}" height="{{height || 200}}" [src]="regaliaFrame"></iframe> -->
                  <object name="search_iframe" [data]="regaliaFrame" width="100%" height="{{height || 200}}" type="text/html"></object>
               </ng-template>

            </div>
         </mat-tab>
         <!---
         <mat-tab label="Resultado Operativo" *ngIf="dev.operation.length">
            <div class="container-info border-xs-0">
               <mnf-project-info-operation [dev]="dev" [selectedIndex]="selectedIndex"  [parts]="devParts"></mnf-project-info-operation>
            </div>
         </mat-tab>
         -->
         <mat-tab label="Actualizaciones">
            <div class="container-info border-xs-0">
               <mnf-project-info-updates [dev]="dev" [userParts]="user?.participations" [selectedIndex]="selectedIndex"></mnf-project-info-updates>
            </div>
         </mat-tab>
      </mat-tab-group>
   </div>

</div>
